import {
  Root as Dialog,
  DialogContent,
  DialogPortal
} from '@radix-ui/react-dialog'
import LocationPickerButton from 'component/block/locationPicker/button'
import { useEffect, useState } from 'react'

import { useIsMobile } from 'store/server-context/device'
import { usePickerOpenStore } from 'store/global/picker-open'
import calculateMainLeft from 'util/calculateMainLeft'
import cn from 'util/cn'
import LocationDropdown from './locationDropdown'

const preventAutoFocus = (e: Event) => {
  e.preventDefault()
}

interface IDropdownMenu {
  menuTitles: { id: string; title: string }[]
  currentTitle: {
    index: number
    title: string
  } | null
}
const LocationPicker = ({ menuTitles, currentTitle }: IDropdownMenu) => {
  const showCard = usePickerOpenStore(state => state.pickerOpen)
  const setShowCard = usePickerOpenStore(state => state.setPickerOpen)
  const isMobile = useIsMobile()

  const [left, setLeft] = useState('')

  useEffect(() => {
    if (isMobile) {
      return
    }
    const handleResize = () => {
      const left = calculateMainLeft()
      setLeft(left)
    }
    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [isMobile])

  return (
    <Dialog open={showCard} onOpenChange={setShowCard} modal={true}>
      <LocationPickerButton
        currentTitle={currentTitle}
        menuTitles={menuTitles}
      />
      <DialogPortal>
        <DialogContent
          style={{ '--left': left } as React.CSSProperties}
          data-side='bottom'
          className={cn(
            'fixed top-[--fixed-top] z-popover transform bg-background-1st',
            isMobile
              ? 'left-0 h-[calc(100%_-_var(--cookie-hint-height)_-_96px_-_var(--fixed-top))] w-screen'
              : 'left-[--left] w-[380px] -translate-x-1/2 translate-y-[8px] rounded-[12px] shadow-floating-dropdown data-[state=closed]:slide-out-to-left-1/2 data-[state=open]:slide-in-from-left-1/2',
            'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=open]:slide-in-from-top-2',
            'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=closed]:slide-out-to-top-2'
          )}
          onOpenAutoFocus={preventAutoFocus}
        >
          <LocationDropdown />
        </DialogContent>
      </DialogPortal>
    </Dialog>
  )
}

export default LocationPicker
